import React, { FormEvent } from "react";
import { Button, Col, Container, Form, FormGroup, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Polygon } from "geojson";

import NavBar from "./common/components/NavBar";
import LoadingIndicator from "./common/components/LoadingIndicator";
import { routes } from "../Router";
import { createLeadSearch } from "../api/LeadSearch";
import DrawSinglePolygonMap, {
  DrawSinglePolygonMapHandle,
} from "./components/google-maps/DrawSinglePolygonMap/DrawSinglePolygonMap";
import config from "../config";

export default function LeadSearchCreate(): React.JSX.Element {
  const navigate = useNavigate();

  const mapRef = React.useRef<DrawSinglePolygonMapHandle | null>(null);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [leadSearchTitle, setLeadSearchTitle] = React.useState<string>("");
  const [leadSearchFocusAreaPolygon, setLeadSearchFocusAreaPolygon] =
    React.useState<Polygon | null>(null);

  const handleCreateLeadSearch = (e: FormEvent<HTMLFormElement>) => {
    /**
     * Handle the form submission to create a new lead search.
     */
    e.preventDefault();
    if (leadSearchFocusAreaPolygon) {
      setIsLoading(true);
      createLeadSearch(leadSearchTitle, leadSearchFocusAreaPolygon).then(
        (leadSearch: ILeadSearch) =>
          navigate(routes.leadSearchDetail(leadSearch.id)),
      );
    }
  };

  return (
    <Container fluid={true} className="w-100 min-h-100vh d-flex flex-column">
      <NavBar isLoading={isLoading} previousPath={routes.root} />
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <div className="d-flex flex-column flex-grow-1 justify-content-between align-items-center mt-3">
          <div className="d-flex flex-column flex-grow-1 w-100">
            <h3 className="text-start mb-3">Nieuwe zoekopdracht</h3>
            <Row className="flex-grow-1 mb-3">
              <Col>
                <div className="d-flex flex-column flex-grow-1 h-100">
                  <Form.Label>
                    <h5 className="mb-0">Focusgebied</h5>
                  </Form.Label>
                  <DrawSinglePolygonMap
                    ref={mapRef}
                    defaultCenter={config.headquartersLocation}
                    setPolygon={setLeadSearchFocusAreaPolygon}
                  />
                </div>
              </Col>
              <Col>
                <Form
                  className="d-flex flex-column flex-grow-1 h-100 justify-content-between align-items-center"
                  onSubmit={handleCreateLeadSearch}
                >
                  <div className="w-100">
                    <FormGroup className="mb-4">
                      <Form.Label htmlFor="title">
                        <h5 className="mb-0">Titel</h5>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        id="title"
                        placeholder='Bijvoorbeeld "Huurders voor de Erasmusweg 3"'
                        required={true}
                        value={leadSearchTitle}
                        onChange={(e) => setLeadSearchTitle(e.target.value)}
                      />
                      <Form.Text muted={true}>
                        Vul hier een omschrijvende titel in.
                      </Form.Text>
                    </FormGroup>
                  </div>
                  <div className="d-flex w-100 justify-content-between">
                    <Button
                      title="Reset focusgebied"
                      type="button"
                      variant="outline-primary"
                      className="px-4 me-3"
                      onClick={mapRef.current?.clearPolygon}
                      disabled={!leadSearchFocusAreaPolygon}
                    >
                      Reset focusgebied
                    </Button>
                    <Button
                      title="Volgende"
                      type="submit"
                      variant="primary"
                      className="px-4"
                      disabled={!leadSearchTitle || !leadSearchFocusAreaPolygon}
                    >
                      Volgende
                    </Button>
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </Container>
  );
}
